// extracted by mini-css-extract-plugin
module.exports = {"search":"SearchAppUsers_search__3ux0s"};